module.exports = require("core-js/modules/es.reflect.construct.js");